'use client';
// 活動內容頁 banner
import Image from 'next/image';
import EventsTag from './EventsTag';
import EventsTagInfo from './EventsTagInfo';
import { EVENTS_FILTER_MAP } from '@/common/constant';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const EventsActivityBanner = ({ img, title, place, beginTime, progressStatus, labels }) => {
    const { t } = useTranslation();

    const time = beginTime ? dayjs(beginTime).format('YYYY.MM.DD HH:mm') : '---';

    const filterKeys = Object.keys(EVENTS_FILTER_MAP);
    const filterKey = filterKeys[progressStatus];

    // 標籤篩選
    const label = labels?.filter((l) => l === 'offline' || l === 'online') || null;

    const activityProcessColor = (process) => {
        // 1:進行中, 2:即將開始, 3:已結束)
        switch (process) {
            case 1:
                return 'bg-pale';
            case 2:
                return 'bg-black2';
            case 3:
                return 'bg-black';
        }
    };
    return (
        <div>
            <div className="img-box w-full aspect-[250/136] rounded-[4px] overflow-hidden">
                <Image
                    className="hover-img"
                    width={728}
                    height={357}
                    src={img || '/images/news/default_related.svg'}
                    alt="event_image"
                />
            </div>
            <div className="text-bd6b text-[32px] tracking-[.08px] leading-[140%] mt-[20px] pb-[20px] relative ulg:text-bd5b border-b-1 border-black2 border-opacity-[.5]">
                {title}
            </div>
            <div className="w-full flex gap-x-[14px] flex-wrap">
                <p className="flex items-center space-x-[4px] text-bd4n text-black5 mt-[20px]">
                    {/* 線上線下標籤 */}
                    {label && <EventsTag content={t(label[0]?.toUpperCase())} color={'bg-black'} />}
                    <EventsTag
                        content={t(filterKey)}
                        color={activityProcessColor(progressStatus)}
                    />
                </p>
                <div className="flex items-center gap-x-[12px] text-bd4n text-black5 mt-[20px] usm:flex-wrap">
                    <p className="flex items-center space-x-[12px]">
                        <EventsTagInfo content={time} title={t('TIME')} />
                        <span>/</span>
                    </p>
                    <p className="flex items-center space-x-[12px]">
                        <EventsTagInfo content={place} title={t('PLACE')} />
                    </p>
                </div>
            </div>
        </div>
    );
};

export default EventsActivityBanner;
